import { render, staticRenderFns } from "./cusitemrelation.vue?vue&type=template&id=62b4a23e&scoped=true&"
import script from "./cusitemrelation.vue?vue&type=script&lang=js&"
export * from "./cusitemrelation.vue?vue&type=script&lang=js&"
import style0 from "./cusitemrelation.vue?vue&type=style&index=0&id=62b4a23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b4a23e",
  null
  
)

export default component.exports